export const ageMethod = "age nearest";
export const gateway = "https://quickterm-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/wawanesalife";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3YXdhbmVzYWxpZmUiLCJuYW1lIjoid2F3YW5lc2FsaWZlIiwiaWF0IjoxNzg1MzU1MjExLCJleHAiOjE5NDMxNDMyMTF9.SdpQsbmRzChXa-IpLHvizqbr-zTND2ryv_4M-xp7AhI";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.5'
};
export const brokerBranding = {
	"quickterm.link.wawanesalife.com": {
		a: {
			accessibilityLink: "https://www.wawanesa.com/canada/about-us/accessibility",
			approve_company: "Link Platform",
			approve_user: "link_wawanesalife",
			brands: [
				"quickterm.link.wawanesalife.com",
			],
			broker: "link_wawanesalife",
			broker_formatted_name: "Wawanesa Life",
			email: "lifeclient@wawanesa.com",
			environment: "stable",
			environment_id: "stable",
			g4: "GTM-PRVB33W3",
			layout: "corpo",
			logoPosition: "menu",
			"maps": {
				"AB branch": [
					"5008 86 Street NW",
					"Edmonton",
					"AB",
					"T6E 5S2",
				],
				"Head office": [
					"236 Carlton St",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
			},
			menuPhone: "button",
			phone: "1-888-997-9965",
			photos: [
				"people1.jpg",
				"building1.jpg",
				"people2.jpg",
				"building2.jpg",
			],
			privacyLink: "https://www.wawanesalife.com/pip/privacy.html",
			tcLink: "https://www.wawanesalife.com/pip/terms-and-conditions.html",
			themeSwitcher: "show",
			website: "https://wawanesalife.com/",
			scope: "wawanesalife#branding#quickterm.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "quickterm.link.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://www.wawanesa.com/canada/about-us/accessibility",
			approve_company: "Link Platform",
			approve_user: "link_wawanesalife",
			brands: [
				"quickterm.link.wawanesalife.com",
			],
			broker: "link_wawanesalife",
			broker_formatted_name: "Wawanesa Life",
			email: "lifeclient@wawanesa.com",
			environment: "stable",
			environment_id: "stable",
			g4: "GTM-PRVB33W3",
			layout: "corpo",
			logoPosition: "menu",
			"maps": {
				"AB branch": [
					"5008 86 Street NW",
					"Edmonton",
					"AB",
					"T6E 5S2",
				],
				"Head office": [
					"236 Carlton St",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
			},
			menuPhone: "button",
			phone: "1-888-997-9965",
			photos: [
				"people1.jpg",
				"building1.jpg",
				"people2.jpg",
				"building2.jpg",
			],
			privacyLink: "https://www.wawanesalife.com/pip/privacy.html",
			tcLink: "https://www.wawanesalife.com/pip/terms-and-conditions.html",
			themeSwitcher: "show",
			website: "https://wawanesalife.com/",
			scope: "wawanesalife#branding#quickterm.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "quickterm.link.wawanesalife.com",
		},
	},
};

//updated on Wed Jul 29 2026 15:00:11 GMT-0500 (Central Daylight Time)
